<template>
  <div class="add-post">
    <uploaderVideo ref="uploadDiv" :uploadType="2" @uploadSucc="handleUploadSucc"></uploaderVideo>
    <div class="upload-title">
      <input type="text" maxlength="50" v-model="subjectName" placeholder="请填写投票标题，不超过30字" class="input-title" />
    </div>
    <div class="div-block" v-for="(item, index) in options" :key="index">
      <div class="blo-tag">观点{{ index + 1 }}</div>
      <input type="text" v-model="item.optionTxt" placeholder="请填写选项，不超过30个字" maxlength="30" class="blo-input" />
      <img v-if="index > 1" @click="handleDelOptions(index)" src="@/assets/images/zone/img36.png" class="icon-del"
        alt="" />
    </div>
    <div class="div-block bor-btm" @click="handleAddOptions">
      <img src="@/assets/images/zone/img37.png" class="icon-add" alt="" />
      添加观点
    </div>
    <div class="div-flex">
      <div class="flex-label">选择类型</div>
      <van-radio-group v-model="changeRadio" direction="horizontal">
        <van-radio icon-size="14px" checked-color="#EB1700" name="1">单选</van-radio>
        <van-radio icon-size="14px" checked-color="#EB1700" name="2">多选</van-radio>
      </van-radio-group>
    </div>
    <van-field readonly clickable name="picker" class="field-color" :value="cutTime" label="截止时间" placeholder="点击选择截止时间"
      @click="showPickerDate = true" />
    <van-popup v-model="showPickerDate" position="bottom">
      <van-datetime-picker v-model="currentDate" type="datetime" title="截止时间" :min-date="minDate" :max-date="maxDate"
        @confirm="onDateConfirm" @cancel="showPickerDate = false" />
    </van-popup>
    <div class="fixed-btn" :class="{ cur: allInput, upload: uploadPost }" @click="handleAddPost">
      发布
    </div>
  </div>
</template>
<script>
import { addPost, postDetails, updatePost } from '@/api/zone'
import uploaderVideo from './compontents/uploaderVideo.vue'
import { roleIsConsumer, rolesClick } from './data'
import withRouteTracking from '@/utils/withRouteTracking'
import { traceClickURL } from '@/utils/util'
const UserProfile = {
  components: {
    uploaderVideo
  },
  data () {
    return {
      content: '',
      subjectName: '',
      form: {},
      areaId: '', // 专区Id
      fileIds: [],
      adminFileMainId: '',
      showPicker: false,
      changeRadio: '1',
      fromType: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2027, 10, 1),
      currentDate: new Date(),
      cutTime: '',
      showPickerDate: false,
      options: [
        {
          optionTxt: ''
        },
        {
          optionTxt: ''
        }
      ],
      uploadPost: false,
      contentMaxLength: 1000
    }
  },
  computed: {
    allInput () {
      return this.subjectName.length > 0
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  created () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo)) {
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
      return
    }
    this.areaId = this.$route.query.areaId
    this.dccId = this.$route.query.dccId
    if (this.dccId) {
      postDetails({ postbarId: this.dccId }).then(res => {
        this.areaId = res.data.areaId
        this.subjectName = res.data.subjectName
        this.content = res.data.content
        this.adminFileMainId = this.dccId
        this.cutTime = res.data.cutTime
          ? this.$moment(new Date(Number(res.data.cutTime)).getTime()).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          : ''
        this.changeRadio = res.data.selectType ? `${res.data.selectType}` : '1'
        this.options = res.data.voteListSelectedDTOS.map(item => {
          return {
            optionTxt: item.content
          }
        })
        this.$refs.uploadDiv.handleFun(this.adminFileMainId)
      })
    }
    this.fromType = this.$route.query.fromType
  },
  methods: {
    handleAddOptions () {
      this.options.push({
        optionTxt: ''
      })
    },
    handleDelOptions (index) {
      this.options.splice(index, 1)
    },
    onDateConfirm (value) {
      this.cutTime = this.$moment(new Date(value).getTime()).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.showPickerDate = false
    },
    getPlainTextLen (richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      // if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
      //   this.$toast('字数超过1000！')
      //   return
      // }
      if (!this.cutTime) {
        this.$toast('请选择截止时间')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      let params = {
        id: this.dccId,
        areaId: this.areaId,
        type: '2',
        userId: this.userInfo.id,
        subjectName: this.subjectName,
        // content: this.content,
        fileIds:
          this.uploadList && this.uploadList.length > 0
            ? this.uploadList.map(res => res.id)
            : [],
        // kind: 类别1RTC2病例交流3心电图交流)
        kind: this.fromType === 'case' ? '2' : '1',
        // 单选多选
        selectType: this.changeRadio,
        cutTime: this.cutTime,
        voteInfo: this.options.map((res, index) => {
          return {
            number: index + 1,
            content: res.optionTxt,
            postbarId: '',
            userId: this.userInfo.id
          }
        })
      }
      if (params.id) {
        const fileList = this.fileList
          .filter(item => item.id)
          .map(item => item.id)
        params.fileIds = fileList.concat(params.fileIds)
        delete params.kind
        updatePost(params).then(res => {
          this.$toast('发布成功')
          setTimeout(() => {
            this.$router.push({
              path: `/dcc`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addPost(params).then(res => {
          this.$toast('发布成功')
          setTimeout(() => {
            if (this.fromType === 'case') {
              setTimeout(() => { traceClickURL() })
              window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?index=1&listType=4`
            } else {
              this.$router.push({
                path: `/zoneDetails?areaId=${this.areaId}`
              })
            }
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    },
    onConfirm (e) {
      this.caseValue = e
      this.showPicker = false
    },
    handleUploadSucc (succon) {
      this.uploadList = succon.uploadList
      this.fileList = succon.uploadList
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.upload-title {
  width: 100%;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;
  padding: 0 14px;
  margin-bottom: 10px;

  .input-title {
    line-height: 55px;
    height: 55px;
    border: none;
    border-bottom: 1px solid #ebedf0;
    font-weight: 600;
    outline: none;
    background-color: transparent;
    width: 100%;
    font-size: 18px;
    color: #282828;

    &::placeholder {
      color: #c0c0c2;
    }
  }
}

.div-block {
  display: flex;
  align-items: center;
  height: 50px;
  position: relative;
  margin: 0 14px;
  font-size: 12px;
  color: #343434;

  &.bor-btm {
    border-bottom: 0.5px solid #e8e8e8;
  }

  .icon-add {
    width: 13px;
    height: 13px;
    margin-right: 4px;
  }

  .blo-tag {
    width: 48px;
    height: 24px;
    border-radius: 4px;
    line-height: 24px;
    text-align: center;
    background-color: #f5f5f5;
    font-size: 12px;
    color: #343434;
    margin-right: 10px;
  }

  .blo-input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    border-bottom: 0.5px solid #e8e8e8;
    height: 50px;
    line-height: 50px;
  }

  .icon-del {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
}

/deep/ .van-field__control {
  text-align: right;
}

.div-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 14px;
  height: 42px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}

.add-post {
  padding-bottom: 90px;
  box-sizing: border-box;
}

.fixed-btn {
  position: fixed;
  bottom: 24px;
  left: 14px;
  width: calc(100vw - 28px);
  height: 42px;
  border-radius: 100px;
  background-color: #e6e6e6;
  font-size: 16px;
  color: #aeaeae;
  text-align: center;
  line-height: 42px;
  font-weight: 500;

  &.upload {
    color: #fff;
    background-color: #C0C0C0;
  }

  &.cur {
    color: #fff;
    background-color: #EB1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/addVote.vue